import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Typography,
  Box,
} from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import {
  PYG_AVAILABLE_YEARS,
  MIN_PYG_COMPARE_YEARS,
  MAX_PYG_COMPARE_YEARS,
  normalizeCompareYears,
} from "./pygChartCompareYears";

const PygCompareYearsControl = ({
  value,
  onChange,
  size = "small",
  sx,
  compact = false,
  selectSx,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const years = normalizeCompareYears(value);

  const handleChange = (event) => {
    const raw = event.target.value;
    const selected = typeof raw === "string" ? raw.split(",").map(Number) : raw.map(Number);
    onChange(normalizeCompareYears(selected));
  };

  return (
    <Box
      sx={{
        minWidth: compact ? { xs: "100%", sm: 200 } : { xs: "100%", sm: 260 },
        ...sx,
      }}
    >
      <FormControl size={size} fullWidth>
        <InputLabel id="pyg-compare-years-label">
          {t("pygAnalitico.compareYears")}
        </InputLabel>
        <Select
          labelId="pyg-compare-years-label"
          multiple
          value={years}
          label={t("pygAnalitico.compareYears")}
          onChange={handleChange}
          renderValue={(selected) => [...selected].sort((a, b) => a - b).join(" · ")}
          sx={{
            backgroundColor: alpha(theme.palette.background.paper, 0.92),
            borderRadius: 1.5,
            ...selectSx,
          }}
        >
          {PYG_AVAILABLE_YEARS.map((y) => (
            <MenuItem key={y} value={y}>
              <Checkbox checked={years.includes(y)} size="small" />
              <ListItemText primary={String(y)} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {!compact && (
        <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 0.35 }}>
          {t("pygAnalitico.compareYearsHint", {
            min: MIN_PYG_COMPARE_YEARS,
            max: MAX_PYG_COMPARE_YEARS,
          })}
        </Typography>
      )}
    </Box>
  );
};

export default PygCompareYearsControl;
